<template>
  <div id="box">
    <!-- 头部组件 -->
    <header class="box">
      <headers :is_login="'login'"></headers>
    </header>
    <div class="HE" @click="hemoes">
      华中版权综合服务平台
    </div>
    <!-- 表单部分 -->
    <div class="login"> 
      <div class="content">
    <!-- <div id="tesila"></div> -->
        <div class="login-content">
          <header class="login-title">用户登录</header>
          <div class="flex_nav">
            <div
              class="type1"
              :class="navIndex == 0 ? 'active' : ''"
              @click="changeType(0)"
            >
              密码登录
            </div>
            <div class="line"></div>
            <div
              class="type1"
              :class="navIndex == 1 ? 'active' : ''"
              @click="changeType(1)"
            >
              验证码登录
            </div>
          </div>
          <form class="form">
            <div class="input-box" v-if="navIndex == 0">
              <i class="iconfont icon-account icon"></i>
              <input
                class="username"
                type="text"
                v-model="username"
                placeholder="请输入手机号"
              />
            </div>
            <div class="input-box" v-if="navIndex == 1">
              <i class="iconfont icon-mobile-phone icon"></i>
              <input
                class="username"
                type="text"
                v-model="phone"
                placeholder="请输入手机号"
              />
            </div>
            <div class="input-box" v-if="navIndex == 0">
              <i class="iconfont icon-password icon"></i>
              <input
                class="password"
                type="password"
                v-model="password"
                placeholder="请输入密码"
              />
            </div>
            <div class="input-box">
              <input
                type="text"
                v-model="usercode"
                placeholder="请输入图形验证码"
              />
              <!-- <div class="verificationcode" @click="checkCodeofRandom">{{ Graphicverificationcode }}</div> -->
              <img-verify @imgCode="imgCode"/>
            </div>
            <div class="input-box" v-if="navIndex == 1">
              <input type="text" v-model="smsCode" placeholder="请输入验证码" />
              <div class="getverificationcode" @click="getCode">
                {{ content }}
              </div>
            </div>
            <div class="forget" @click="forget">忘记密码？</div>
            <div class="submit" @click="submit">立即登录</div>
            <div class="register-box">
              还没有账号？<span class="register" @click="register"
                >立即注册</span
              >
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- 尾部组件 -->
    <div class="box">
      <tails></tails>
    </div>
  </div>
</template>

<script>
import preventBack from "vue-prevent-browser-back";
import headers from "@/components/header";
import tails from "@/components/tail";
import imgVerify from "@/components/imgVerify";
export default {
  // mixins: [preventBack],
  data() {
    return {
      navIndex: 0,
      username: "",
      password: "",
      Graphicverificationcode: "",
      phone: "",
      verificationcode: "",
      usercode: "",
      reg_tel: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      smsCode: "",
      totalTime: 60,
      content: "获取验证码",
      canClick: true,
    };
  },
  components: {
    headers,
    tails,
    imgVerify,
  },
  mounted() {
    // this.checkCodeofRandom();
    sessionStorage.removeItem("userInfo");
  },
  methods: {
    hemoes(){
      window.localStorage.setItem("cur",0);
      this.$router.push("/");
    },
    imgCode(code){
      this.Graphicverificationcode = code;
      // console.log(code,"[[[][]")
    },
    changeType(index) {
      // console.log(index)
      this.navIndex = index;
    },
    // checkCodeofRandom() {
    //   var nums = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9");
    //   // 初始化 拼接字符串
    //   var str = "";
    //   for (let i = 0; i < 4; i++) {
    //     var p = Math.floor(Math.random() * 1000) % 10;
    //     //拼接验证码  随机抽取大小写字母和数字
    //     str += nums[p];
    //   }
    //   this.Graphicverificationcode = str;
    // },
    getCode() {
      // console.log("code");
      this.phone = this.phone.trim();
      if (!this.reg_tel.test(this.phone)) {
        this.$message({
          message: "请填写正确的手机号码!",
          type: "error",
        });
        return;
      }
      this.$getHttp("/pc/userLogin/existPhone", {
        phone: this.phone,
      })
        .then((res) => {
          // console.log(res);
          if (!this.canClick) return; //改动的是这两行代码
          this.canClick = false;
          this.content = this.totalTime + "s后重新发送";
          let clock = window.setInterval(() => {
            this.totalTime--;
            this.content = this.totalTime + "s后重新发送";
            if (this.totalTime < 0) {
              window.clearInterval(clock);
              this.content = "重新发送验证码";
              this.totalTime = 60;
              this.canClick = true; //这里重新开启
            }
          }, 1000);
          this.$getHttp("/pc/userLogin/phoneVerification", {
            phone: this.phone,
          })
            .then((res) => {
              // console.log(res);
              this.verificationcode = res.code;
            })
            .catch((error) => {
              // console.log(error);
            });
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    forget() {
      this.$router.push("/success");
    },
    register() {
      this.$router.push("/register");
    },
    submit() {
      this.username = this.username.trim();
      this.phone = this.phone.trim();
      if (this.navIndex == 0) {
        if (this.usercode == "" || !this.usercode) {
          this.$message({
            message: "请填写图形验证码!",
            type: "error",
          });
          return;
        }
        let code = this.usercode.toUpperCase()
        // console.log(this.Graphicverificationcode,"Graphicverificationcode")
        if (code != this.Graphicverificationcode) {
          this.$message({
            message: "请填写正确的图形验证码!",
            type: "error",
          });
          return;
        }
        if (this.username == "" || !this.username) {
          this.$message({
            message: "请填写用户名/手机号!",
            type: "error",
          });
          return;
        }
        if (this.password == "" || !this.password) {
          this.$message({
            message: "请填写密码!",
            type: "error",
          });
          return;
        }
        let data = {
          phone: this.username,
          password: this.password,
        };
        // console.log(data);
        this.$postHttp("/pc/userLogin/passwordLogin", data)
          .then((res) => {
            // console.log(res);
            // this.verificationcode = res.code
            if (res.msg == "操作成功") {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              window.localStorage.setItem(
                "userInfo",
                JSON.stringify(res.user[0])
              );
              console.log(JSON.parse(window.localStorage.getItem("userInfo")))
              this.$router.push("home");
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      } else if (this.navIndex == 1) {
        if (!this.reg_tel.test(this.phone)) {
          this.$message({
            message: "请填写正确的手机号码!",
            type: "error",
          });
          return;
        }
        if (this.usercode == "" || !this.usercode) {
          this.$message({
            message: "请填写图形验证码!",
            type: "error",
          });
          return;
        }
        if (this.smsCode == "" || !this.smsCode) {
          this.$message({
            message: "请填写短信验证码!",
            type: "error",
          });
          return;
        }
        // let code = this.usercode.toUpperCase()
        // if (code != this.Graphicverificationcode) {
        //   this.$message({
        //     message: "请填写正确的图形验证码!",
        //     type: "error",
        //   });
        //   return;
        // }
        // console.log('shurude',this.usercode)
        //  console.log('生产',this.Graphicverificationcode)
        let code = this.usercode.toUpperCase()
        // console.log(this.Graphicverificationcode,"Graphicverificationcode") usercode
        if (code != this.Graphicverificationcode) {
          this.$message({
            message: "请填写正确的图形验证码!",
            type: "error",
          });
          return;
        }
        if (this.smsCode != this.verificationcode) {
          this.$message({
            message: "请填写正确的短信验证码!",
            type: "error",
          });
          return;
        }
        let data = {
          phone: this.phone,
          code: this.smsCode,
        };
        // console.log(data);
        this.$postHttp("/pc/userLogin/codeLogin", data)
          .then((res) => {
            // console.log(res);
            // this.verificationcode = res.code
            if (res.msg == "操作成功") {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              this.$router.push("/");
              
              window.localStorage.setItem(
                "userInfo",
                JSON.stringify(res.r[0]))
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          })
          .catch((error) => {
            // console.log(error);
          });
        // console.log("success");
      }
    },
  },
};
</script>

<style lang='less' scoped>
#box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #f3f6f8;
}
.box {
  // background: #f2f2f2;
}
.login {
  height: calc(100% - 243px);
  min-height: 650px;
  // background-image: linear-gradient(
  //   90deg,
  //   rgba(34, 100, 210, 0.72) 0%,
  //    #0068b7 100%
  // );
  .content {
    position: relative;
    height: 100%;
  }
  .login-content {
    position: absolute;
    top: 50%;
    right: 80px;
    transform: translateY(-50%);
    width: 450px;
    height: 500px;
    background-color: #ffffff;
    border-radius: 20px;
    border: 1px solid #453e3e;
    box-shadow: 0px 0px 16px 0px rgba(181, 181, 181, 0.2);
    overflow: hidden;
    .login-title {
      width: 100%;
      height: 55px;
      line-height: 55px;
      background-color: #f2f2f2;
      text-align: center;
      color:  #0068b7;
      font-size: 24px;
    }
    .flex_nav {
      padding-top: 23px;
      align-items: center;
      width: 350px;
      margin: 0 auto;
      padding-bottom: 28px;
    }
    .line {
      width: 1px;
      height: 28px;
      background: #999999;
    }
    .type1 {
      height: 18px;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 18px;
      letter-spacing: 0px;
      color: #666666;
      cursor: pointer;
    }
    .active {
      color:  #0068b7;
    }
    .form {
      .input-box {
        width: 370px;
        margin: 0 auto;
        position: relative;
        margin-bottom: 16px;
      }
      .icon {
        position: absolute;
        top: 50%;
        left: 17px;
        transform: translateY(-50%);
        color:  #0068b7;
        font-size: 31px;
      }
      input {
        width: 370px;
        height: 56px;
        background-color: #ffffff;
        border-radius: 10px;
        border: solid 1px #707070;
        font-size: 18px;
        box-sizing: border-box;
        padding-left: 15px;
      }
      .username,
      .password {
        padding-left: 59px;
      }
      .verificationcode {
        position: absolute;
        top: 50%;
        right: 7px;
        transform: translateY(-50%);
        width: 80px;
        height: 42px;
        background-color: #d3e0f6;
        border-radius: 8px;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 42px;
        letter-spacing: 2px;
        color:  #0068b7;
        text-align: center;
        cursor: pointer;
      }
      .getverificationcode {
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
        height: 42px;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 42px;
        letter-spacing: 0px;
        text-align: center;
        color: #999999;
        cursor: pointer;
      }
      .forget {
        width: 370px;
        margin: 0 auto;
        position: relative;
        height: 16px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 0px;
        color: #999999;
        text-align: right;
        margin-top: -10px;
        cursor: pointer;
      }
      .submit {
        width: 370px;
        margin: 0 auto;
        height: 50px;
        background-color:  #0068b7;
        border-radius: 10px;
        line-height: 49px;
        color: #fff;
        text-align: center;
        font-size: 18px;
        margin-top: 21px;
        margin-bottom: 13px;
        cursor: pointer;
      }
      .register-box {
        height: 27px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 27px;
        letter-spacing: 0px;
        color: #666666;
        text-align: center;
        margin: 0 auto;
      }
      .register {
        font-size: 16px;
        font-weight: normal;
        letter-spacing: 0px;
        color:  #0068b7;
        cursor: pointer;
      }
    }
  }
}
#tesila{
    width: 650px;
    height: 210px;
    background-repeat: no-repeat;
    background-image: linear-gradient(
161deg
,transparent 11%,#1d232a 11.5%),linear-gradient(
161deg
,transparent 50%,#555 50%),linear-gradient(to right,#1d232a,#1d232a),radial-gradient(circle at center,#ff0 8%,red 30%,transparent 80%),linear-gradient(to right,transparent,rgba(255,0,0,.6) 30%,rgba(255,0,0,.6) 70%,transparent),linear-gradient(to bottom,transparent,rgba(255,0,0,.6) 30%,rgba(255,0,0,.6) 70%,transparent),radial-gradient(circle at center bottom,transparent 45%,rgba(255,255,255,.1) 45%,rgba(255,255,255,.1) 50%,transparent 50%),linear-gradient(to right,rgba(255,255,255,.1),rgba(255,255,255,.1)),linear-gradient(
40deg
,transparent 40%,rgba(255,255,255,.1) 41%,rgba(255,255,255,.1) 44%,transparent 45%),linear-gradient(
-40deg
,transparent 40%,rgba(255,255,255,.1) 41%,rgba(255,255,255,.1) 44%,transparent 45%),linear-gradient(
320deg
,transparent 40%,rgba(0,0,0,.7) 41%,rgba(0,0,0,.7) 44%,transparent 45%),linear-gradient(
-320deg
,transparent 40%,rgba(0,0,0,.7) 41%,rgba(0,0,0,.7) 44%,transparent 45%),radial-gradient(circle,#0f1215 50%,transparent 50%),radial-gradient(circle at center top,rgba(255,255,255,.1) 50%,transparent 50%),radial-gradient(circle at center top,rgba(0,0,0,.4) 50%,transparent 50%),radial-gradient(circle at center bottom,rgba(255,255,255,.1) 50%,transparent 50%),radial-gradient(circle,rgba(0,0,0,.3) 50%,transparent 50%),radial-gradient(circle,#1d232a 50%,transparent 50%),linear-gradient(
70deg
,transparent 10%,#4a596b 11%),linear-gradient(
-60deg
,transparent 10%,#4a596b 11%),linear-gradient(
127deg
,transparent 40%,rgba(0,0,0,.2) 50%,#333d49 51%,#333d49 62%,#000 63%),linear-gradient(
-125deg
,transparent 35%,rgba(0,0,0,.2) 45%,#333d49 46%,#333d49 57%,#000 58%),linear-gradient(to right,#000,#000),radial-gradient(circle at center bottom,transparent 45%,rgba(255,255,255,.1) 45%,rgba(255,255,255,.1) 50%,transparent 50%),linear-gradient(to right,rgba(255,255,255,.1),rgba(255,255,255,.1)),linear-gradient(
40deg
,transparent 40%,rgba(255,255,255,.1) 41%,rgba(255,255,255,.1) 44%,transparent 45%),linear-gradient(
-40deg
,transparent 40%,rgba(255,255,255,.1) 41%,rgba(255,255,255,.1) 44%,transparent 45%),linear-gradient(
320deg
,transparent 40%,rgba(0,0,0,.7) 41%,rgba(0,0,0,.7) 44%,transparent 45%),linear-gradient(
-320deg
,transparent 40%,rgba(0,0,0,.7) 41%,rgba(0,0,0,.7) 44%,transparent 45%),radial-gradient(circle,#0f1215 50%,transparent 50%),radial-gradient(circle at center top,rgba(255,255,255,.1) 50%,transparent 50%),radial-gradient(circle at center top,rgba(0,0,0,.4) 50%,transparent 50%),radial-gradient(circle at center bottom,rgba(255,255,255,.1) 50%,transparent 50%),radial-gradient(circle,rgba(0,0,0,.3) 50%,transparent 50%),radial-gradient(circle,#1d232a 50%,transparent 50%),linear-gradient(
60deg
,transparent 10%,#4a596b 11%),linear-gradient(
-60deg
,transparent 10%,#4a596b 11%),linear-gradient(
127deg
,transparent 32%,rgba(0,0,0,.2) 42%,#333d49 43%,#333d49 53%,#000 54%),linear-gradient(
-125deg
,transparent 22%,rgba(0,0,0,.2) 32%,#1d232a 33%,#1d232a 43%,#000 44%),linear-gradient(to right,#000,#000),linear-gradient(
89deg
,transparent 50%,#000 51%,#000 53%,transparent 54%),linear-gradient(
170deg
,transparent 50%,#000 50%),linear-gradient(
100deg
,transparent 50%,#000 51%,#000 52%,transparent 53%),linear-gradient(
90deg
,transparent 50%,#000 51%,#000 52%,transparent 53%),linear-gradient(to right,rgba(255,255,255,.05),rgba(255,255,255,0)),linear-gradient(
98deg
,transparent 55%,#000 56%),linear-gradient(
176deg
,transparent 32%,#1d232a 33%),linear-gradient(
179deg
,#1d232a 85%,#000 86%),linear-gradient(
179deg
,transparent 40%,#1d232a 45%,#1d232a 50%,transparent 55%),linear-gradient(
105deg
,transparent 50%,#1d232a 51%,#1d232a 53%,transparent 54%),linear-gradient(
100deg
,transparent 50%,#1d232a 51%,#1d232a 53%,transparent 54%),linear-gradient(
81deg
,transparent 50%,#1d232a 51%,#1d232a 53%,transparent 54%),linear-gradient(
81deg
,transparent 38%,#000 40%,#000 49%,#ddd 51%),linear-gradient(to right,rgba(0,0,0,.3),transparent),linear-gradient(to left,rgba(0,0,0,.3),transparent),linear-gradient(
161deg
,#000 50%,#ddd 51%,#ddd 55%,transparent 56%),linear-gradient(
-174deg
,#000 33%,#ddd 34%,#ddd 40%,transparent 41%),linear-gradient(to right,#ddd,#ddd),linear-gradient(
176deg
,transparent 34%,#000 35%,#000 45%,#ddd 46%,#ddd 60%,transparent 60%),linear-gradient(
161deg
,#000 56%,transparent 57%),linear-gradient(
-174deg
,#000 41%,transparent 42%),linear-gradient(
105deg
,transparent 30%,rgba(255,255,255,.05) 31%,rgba(255,255,255,.05) 40%,rgba(0,0,0,.6) 41%,rgba(0,0,0,.6) 45%,rgba(255,255,255,.1) 46%,rgba(255,255,255,.1) 55%,transparent 56%),linear-gradient(
103deg
,transparent 30%,rgba(255,255,255,.1) 31%,rgba(255,255,255,.1) 34%,rgba(0,0,0,.3) 35%,rgba(0,0,0,.3) 38%,transparent 39%),linear-gradient(
93deg
,transparent 29%,rgba(0,0,0,.2) 30%,rgba(0,0,0,.2) 33%,rgba(255,255,255,.1) 34%,rgba(255,255,255,.1) 50%,transparent 51%),linear-gradient(to right,rgba(0,0,0,.3) 20%,rgba(255,255,255,.3) 21%),linear-gradient(to top,rgba(255,255,255,.9) 50%,rgba(255,255,255,0) 65%),linear-gradient(to right,rgba(255,255,255,0),rgba(255,255,255,.3) 60%,rgba(255,255,255,.7));
    background-size: 20px 45px,5px 5px,26px 10px,12px 12px,55px 1px,1px 55px,130px 65px,10px 7px,16px 16px,16px 16px,16px 16px,16px 16px,20px 20px,24px 12px,34px 16px,34px 16px,90px 90px,130px 130px,40px 6px,40px 6px,35px 38px,40px 51px,78px 60px,130px 65px,10px 7px,16px 16px,16px 16px,16px 16px,16px 16px,20px 20px,24px 12px,34px 16px,34px 16px,90px 90px,130px 130px,40px 9px,40px 9px,60px 58px,60px 55px,75px 60px,30px 80px,150px 30px,30px 80px,30px 95px,45px 45px,20px 120px,600px 87px,500px 50px,254px 20px,30px 30px,30px 30px,30px 30px,25px 22px,200px 100px,200px 100px,230px 80px,370px 80px,220px 60px,550px 50px,230px 80px,370px 80px,30px 80px,30px 80px,30px 80px,10px 80px,7px 80px,350px 60px;
    background-position: 5px 80px,0 125px,0 128px,right 25px top 35px,right top 40px,right 30px top 15px,25px 90px,85px 123px,68px 130px,96px 130px,68px 160px,96px 160px,80px 145px,78px 156px,73px 156px,73px 140px,45px 110px,25px 90px,50px 89px,90px 89px,20px 89px,124px 89px,52px 89px,435px 90px,495px 123px,478px 130px,506px 130px,478px 160px,506px 160px,490px 145px,488px 156px,483px 156px,483px 140px,455px 110px,435px 90px,460px 78px,500px 78px,416px 78px,512px 78px,465px 78px,150px 70px,500px 115px,250px 65px,380px 55px,25px 80px,right 25px top 15px,25px 39px,115px 90px,165px 145px,148px 60px,257px 52px,380px 42px,380px 23px,25px 0,right 25px top 0,25px 0,right 25px top 0,right 25px top 20px,50px 29px,25px 0,right 25px top 0,170px 30px,260px 10px,277px 10px,382px 10px,375px 0,50px 0;
}
 .HE{
   display: none;
 }

@media screen and (max-width:1024px) {
    .login{
      width: 100%;
      background: white;
    }
    .box{
      display: none;
    }
    .content {
      width: 100%;
    }
    .login .login-content{
      position: absolute;
      // top: 50%;
      margin-top:  -1.335rem;
      right:50%;
      // -webkit-transform: translateY(-50%);
      // transform: translateY(-50%);
      width:21.835rem;
      // height: 500px;
      margin-right:  -10.9175rem;
      background-color: #ffffff;
      border-radius: 20px;
      overflow: hidden;
    }
    .login .login-content .form input{
       width: 19rem;
       height: 3.335rem;
       display: block;
        margin: 0 auto;
}
.login .login-content .form .icon{
// width: 19rem;
}
.login .login-content .form .input-box{
width: 19rem;
}
.login .login-content .form .forget{
  width: 19rem;
}
    .login .login-content .login-title{
      display: none;
    }
    .login .login-content .line{
      display: none;
    }
    .login .login-content .flex_nav{
      width: 19rem;
      height: 3.335rem;
      background: #F4F4F4;
      padding: 0rem;
      // margin-top: 3.335rem;
      border-radius: 2rem;
      margin-bottom: 3.75rem;
    }
    .login .login-content .active{
      color: white;
      height: 3.335rem;
      width: 10.625rem;
      border-radius: 2rem;
      background: #0068b7;
    }
    .login .login-content .type1{
      flex: 1;
      text-align: center;
      height: 3.335rem;
      line-height: 3.335rem;
      font-size: 1.125rem;
      width: 10.625rem;
    }
    .login .login-content .form .submit{
      width: 19rem;
    }
    .HE{
      display: block;
      width: 100%;
      background: white;
      border-bottom: 1px solid #d6d6d6;
      height: 3.65rem;
      line-height: 3.65rem;
      font-size: 1.1rem;
      text-align: center;
      color: #333333;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/login.vue